/* SNKRR mobile menu & drawer enhancements
   - Injects a visible close X into the mobile menu drawer (Dawn ships none)
   - Forces cart drawer close button to show even when cart is empty
   - Inlines the required CSS so we don't depend on snkrr-redesign.css updates
   build:v2026-05-30-close-x */
(function () {
  'use strict';

  var css = ''
    + '.snkrr-menu-close{'
    +   'position:absolute;top:12px;right:12px;width:44px;height:44px;'
    +   'display:flex;align-items:center;justify-content:center;'
    +   'background:transparent;border:0;cursor:pointer;color:#fff;z-index:10;'
    + '}'
    + '.snkrr-menu-close::before,.snkrr-menu-close::after{'
    +   'content:"";position:absolute;width:22px;height:2px;background:currentColor;'
    + '}'
    + '.snkrr-menu-close::before{transform:rotate(45deg);}'
    + '.snkrr-menu-close::after{transform:rotate(-45deg);}'
    + '.snkrr-menu-close:focus-visible{outline:2px solid #BBF07C;outline-offset:2px;}'
    + 'cart-drawer.is-empty .drawer__header{display:flex !important;}'
    + 'cart-drawer .drawer__close{'
    +   'color:#1a1a1a !important;background:transparent;border:0;'
    +   'width:44px;height:44px;'
    +   'display:flex;align-items:center;justify-content:center;cursor:pointer;'
    + '}'
    + 'cart-drawer .drawer__close svg{width:18px;height:18px;}'
    + 'cart-drawer .drawer__header{padding:16px 20px;border-bottom:1px solid rgba(0,0,0,0.08);}'
    + 'cart-drawer .drawer__heading{margin:0;font-size:16px;font-weight:700;text-transform:uppercase;letter-spacing:1px;}';
  var style = document.createElement('style');
  style.setAttribute('data-snkrr-menu-fix', '');
  style.appendChild(document.createTextNode(css));
  document.head.appendChild(style);

  function initMenuClose() {
    var drawer = document.querySelector('details.menu-drawer-container > .menu-drawer');
    if (!drawer || drawer.querySelector('.snkrr-menu-close')) return;
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'snkrr-menu-close';
    btn.setAttribute('aria-label', 'Close menu');
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      var details = btn.closest('details');
      if (details) {
        details.classList.remove('menu-opening');
        details.removeAttribute('open');
      }
    });
    drawer.appendChild(btn);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMenuClose);
  } else {
    initMenuClose();
  }
})();

/* SNKRR — open Fried Hard Blvd (sister store) links in a new tab.
   Shopify menu links can't set target in admin, so set it here.
   Covers the nav menu item + any other friedhardblvd.com link.
   build:v2026-06-06-fhb-newtab */
(function () {
  'use strict';
  function tagLinks() {
    var links = document.querySelectorAll('a[href*="friedhardblvd.com"]');
    for (var i = 0; i < links.length; i++) {
      links[i].setAttribute('target', '_blank');
      var rel = links[i].getAttribute('rel') || '';
      if (rel.indexOf('noopener') === -1) {
        links[i].setAttribute('rel', (rel + ' noopener noreferrer').trim());
      }
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', tagLinks);
  } else {
    tagLinks();
  }
})();

/* SNKRR — wire the sticky mobile "Add to cart" bar to the real product form.
   The .snkrr-sticky-cta__btn was a dead anchor (#fragment) that did nothing.
   Delegate its click to the actual add-to-cart button so it adds + opens the drawer.
   build:v2026-06-06-sticky-atc */
(function () {
  'use strict';
  document.addEventListener('click', function (e) {
    var sticky = e.target.closest('.snkrr-sticky-cta__btn');
    if (!sticky) return;
    var addBtn = document.querySelector('product-form button[name="add"]:not([disabled])');
    if (addBtn) {
      e.preventDefault();
      addBtn.click();
    }
  });
})();
